<template>
  <div class="utm-source-groups-editor">
    <div
      v-for="(sources, medium) in localValue"
      :key="medium"
      class="utm-source-groups-editor__row"
    >
      <div class="utm-source-groups-editor__medium">
        <v-text-field
          :value="medium"
          placeholder="Medium (e.g. social, email)"
          outlined
          rounded
          hide-details="auto"
          @change="renameMedium(medium, $event)"
        />
        <v-btn icon small @click="removeMedium(medium)">
          <v-icon>$delete</v-icon>
        </v-btn>
      </div>
      <v-combobox
        :value="sources"
        @input="updateSources(medium, $event)"
        placeholder="Add a source and press enter"
        multiple
        chips
        deletable-chips
        hide-selected
        outlined
        rounded
        hide-details="auto"
      />
    </div>

    <div class="utm-source-groups-editor__add">
      <v-text-field
        v-model="newMediumName"
        placeholder="New medium name"
        outlined
        rounded
        hide-details="auto"
        @keypress.enter="addMedium"
      />
      <v-btn outlined color="primary" rounded @click="addMedium">
        Add Medium
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      newMediumName: "",
    };
  },
  computed: {
    localValue() {
      return this.value || {};
    },
  },
  methods: {
    emitUpdate(next) {
      this.$emit("input", next);
    },
    updateSources(medium, sources) {
      this.emitUpdate({ ...this.localValue, [medium]: sources });
    },
    renameMedium(oldName, newName) {
      newName = (newName || "").trim();
      if (!newName || newName === oldName) return;
      if (Object.prototype.hasOwnProperty.call(this.localValue, newName)) {
        return;
      }

      const next = {};
      Object.entries(this.localValue).forEach(([medium, sources]) => {
        next[medium === oldName ? newName : medium] = sources;
      });
      this.emitUpdate(next);
    },
    removeMedium(medium) {
      const next = { ...this.localValue };
      delete next[medium];
      this.emitUpdate(next);
    },
    addMedium() {
      const name = this.newMediumName.trim();
      if (!name || Object.prototype.hasOwnProperty.call(this.localValue, name))
        return;

      this.emitUpdate({ ...this.localValue, [name]: [] });
      this.newMediumName = "";
    },
  },
};
</script>

<style scoped lang="scss">
.utm-source-groups-editor {
  width: 100%;

  &__row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 12px;

    & > *:last-child {
      flex: 1;
    }
  }

  &__medium {
    display: flex;
    align-items: center;
    gap: 4px;
    width: 220px;
    flex-shrink: 0;
  }

  &__add {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 8px;

    .v-text-field {
      width: 220px;
      flex-shrink: 0;
    }
  }
}
</style>
